<template>
  <main>
    <div class="teacher">
      <div class="row">
        <div class="col-md-12">
          <TopTemplate>
            <template v-slot:left-element>
              <h3>{{ $t('title.categorie') }} ({{ total }})</h3>
            </template>

            <template v-slot:right-element>
              <b-button @click="openModalCategory" class="btn button btn-primary"><i class="icon-Add"/> {{ $t('button.addCategorie') }}</b-button>
            </template>
          </TopTemplate>
        </div>
      </div>
    </div>

    <div v-if="loading" class="card mt-4 text-center d-block pt-4 pb-4">
      <div class="spinner-border text-info" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <div v-else>
    <b-alert v-if="errorExist" show variant="danger">{{ $t('error.existCategorie') }}</b-alert>
    <div v-if="noCat" class="container-fluid empty-message card mt-4">
          <div class="col-12 empty-result text-center pt-3">
            <p>{{ $t("common.emptysearshCategory") }}</p>
          </div>
    </div>
  <div v-else class="table category" >
    <div class>
      <div class="row">
        <div class="col-md-12">
          <div class="table__wrapper">
            <table>
              <thead>
                <tr>   
                  <th class="title" >
                    {{ $t('categorie.title') }} 
                    <div class="icon-wrapper">
                      <div class="icon-wrapper" @click="sortB('name')">
                        <i
                          class="ri-arrow-up-s-line"
                          :class="[specTri('name', true)]"
                        />
                        <i
                          class="ri-arrow-down-s-line"
                          :class="[specTri('name', false)]"
                        />
                      </div>
                    </div>
                  </th>
                  <th class="action">{{ $t('common.actions') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="category in categories" :key="category.id">         
                  <td><span v-if="category.name">{{ category.name }}</span><span v-else>__</span></td>
                  <td class="action articles">
                    <a @click="categoryById(category.id)">
                      <i class="icon-edit-02">
                        <span class="tooltiptext">{{ $t('button.tooltip.update') }}</span>
                      </i>
                    </a>
                    <i
                      class="icon-trash"
                      @click.prevent="deletecategory(category.id)"
                    >
                      <span class="tooltiptext">{{ $t('button.tooltip.delete') }}</span>
                    </i>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="table__wrapper__pagination-wrapper">
              <div class="pagination">
                <pagination v-if="last_page > 1" :dataSet="pagination" @goToPage="getResults" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
  <!-- modal -->
    <b-modal v-model="showModalAdd" centered title="Ajouter catégorie" hide-footer>
      <form @submit.prevent="onSubmitAddCategory" novalidate>
        <div class="simple-input">
          <label class="label">
            {{ $t('categorie.titleCatgerie') }}
            <sup>*</sup>
          </label>
          <div>
            <input
              type="text"
              v-model="categoryTitle"
              class="form-control"
              :class="
                v$.categoryTitle.$error ? 'is-invalid' : ''
              "
            />
            <span
            v-if="v$.categoryTitle.$error"
              class="invalid-feedback"
            >
              {{ v$.categoryTitle.$errors[0].$message }}
            </span>
          </div>
        </div>
        <div class="col-12 buttons btn-action-modal mt-4">
          <button :disabled="loading" type="submit" class="btn button btn-primary right-btn"><i class="icon-Check"></i>{{ $t('button.add') }}</button>
          <button @click="cancelAddCategory()" class="btn btn-outline-primary button left-btn"><i class="icon-Add"></i>{{ $t('button.annuler') }}</button>
        </div>
      </form>
    </b-modal>
    <b-modal v-model="showModalEdit" centered title="Modifier catégorie" hide-footer>
      <form @submit.prevent="onSubmitEditCategory" novalidate>
        <div class="simple-input">
          <label class="label">
            {{ $t('categorie.titleCatgerie') }}
            <sup>*</sup>
          </label>
          <div>
            <input
              type="text"
              v-model="categoryTitle"
              class="form-control"
              :class="
                v$.categoryTitle.$error ? 'is-invalid' : ''
              "
            />
            <span
            v-if="v$.categoryTitle.$error"
              class="invalid-feedback"
            >
              {{ v$.categoryTitle.$errors[0].$message }}
            </span>
          </div>
        </div>
        <div class="col-12 buttons btn-action-modal mt-4">
          <button :disabled="loading" type="submit" class="btn button btn-primary right-btn"><i class="icon-Check"></i>{{ $t('button.envoi') }}</button>
          <button @click="cancelEditCategory()" class="btn btn-outline-primary button left-btn"><i class="icon-Add"></i>{{$t('button.annuler') }}</button>
        </div>
      </form>
    </b-modal>
</main>
</template>
<script>
import TopTemplate from "../../components/toptemplate/TopTemplate.vue";
import pagination from "../../components/navigation/Pagination";
import CategorieService from "../../services/categorie.service";
import useValidate from "@vuelidate/core";
import { required, helpers } from "@vuelidate/validators";
import _ from "lodash";
export default {
  name: "CategoriesList",
  components: {
    TopTemplate,
    pagination
  },
  data() {
    return {
      loading: false,
      total:0,
      last_page:null,
      errorExist: false,
      v$: useValidate(),
      pagination: {},
      params: {
        limit: 7,
        page: 1,
        sort: "created_at",
        order: false,
      },
      categories: [],
      noCat:false,
      categoryTitle:"",
      showModalAdd:false,
      showModalEdit:false,
      categoryId:null,
      isCancel:false,
      isCancelAdd:false,
    };
  },
  validations() {
    return {
      categoryTitle: {
        required: helpers.withMessage(
          this.$t("validation.required"),
          required
        ),
      } 
    };
  },
  mounted() {
    this.categoriesList();
  },
  methods: {
    deletecategory(id) {
      const Swal = require("sweetalert2");
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-confirm  btn-primary",
          cancelButton: "btn  btn-cancel  btn-outline-primary"
        },
        buttonsStyling: false,
        showCloseButton: true
      });
      swalWithBootstrapButtons
        .fire({
          title: this.$t("common.confirmDeleteCategory"),
          icon: "warning",
          showCloseButton: true,
          showCancelButton: true,
          confirmButtonText: this.$t("common.deletIT"),
          cancelButtonText: this.$t("common.noCancel"),
          reverseButtons: true
        })
        .then(result => {
          if (result.isConfirmed) {
            swalWithBootstrapButtons.fire(
              this.$t("common.categoryDeleted"),
              "",
              "success"
            );
            CategorieService.delete(id)
            .then(() => {
                this.getResults();
            })
            .finally(() =>{
              this.loading = false;
            })
          }
        });
        
    },
    specTri(param, order) {
      if (this.params.order === null && this.params.sort === "") {
        return "";
      } else {
        if (this.params.sort === param) {
          if (this.params.order === order) {
            return "ordredA";
          } else {
            return "ordredD";
          }
        } else {
          return "";
        }
      }
    },
    sortB: _.debounce(function (param) {
      this.params.order = this.params.order === false ? true : false;
      this.params.sort = param
      this.categoriesList();
    }, 200),
    sort(order, sort) {
      this.params.order = order;
      this.params.sort = sort;
      this.categoriesList();
    },
    categoriesList() {
      this.loading = true;
      CategorieService.getAll({
        params: {
          limit: this.params.limit,
          sort: this.params.sort,
          order: this.params.order
        },
      })
      .then((res) => {
        this.categories = res.data.data;
        this.noCat= this.categories.length === 0;
        this.total = res.data.meta.total,
        this.last_page = res.data.meta.last_page;
        this.pagination = this.makePagination(res.data.meta, res.data.links);
      })
      .finally(() =>{
        this.loading = false;
      })
    },
    makePagination(meta, links) {
      return {
        current_page: meta.current_page,
        last_page: meta.last_page,
        next_page_url: links.next,
        prev_page_url: links.prev,
      };
    },
    getResults(page = null) {
      this.params.page = !page ? this.params.page : page;
      this.loading = true;

      CategorieService.getAll({
        params: {
          limit: this.params.limit,
          page: this.params.page,
          sort: this.params.sort,
          order: this.params.order
        },
      }).then((response) => {
          this.categories = response.data.data;
          this.noCat= this.categories.length === 0;
          this.pagination = this.makePagination(
            response.data.meta,
            response.data.links
          );
          this.loading = false;
        })
        .finally(() =>{
          this.loading = false;
        })
    },
    openModalCategory(){
      this.v$.categoryTitle.$reset();
      this.showModalAdd = !this.showModalAdd;
      this.isCancelAdd=false;
      this.categoryTitle="";
    },
    cancelAddCategory(){
      this.showModalAdd= !this.showModalAdd; 
      this.isCancelAdd=true;
    },
    onSubmitAddCategory(){
      this.loading = true;
      this.v$.$validate();
      if (!this.v$.$error && !this.isCancelAdd) {
        let data = {
          name: this.categoryTitle,
        };
        CategorieService.create(data)
        .then(res => {
          this.loading=false;
            if(res.status== 201){
                this.errorExist = false;
                this.categoryTitle="";
                this.v$.$reset();
                this.getResults();
            }
        })
        .catch((error) => {
            this.errorExist= (error.response.status === 422);
        })
        .finally(() => {
          this.$nextTick(() => {
            this.showModalAdd = false;
          });
        });  
      }
    },
    categoryById(id){
      this.showModalEdit= !this.showModalEdit;
      this.categoryId= id;
      this.isCancel=false;
      CategorieService.get(id)
        .then(res => {
          this.categoryTitle= res.data.name;
        })
        .catch((error)=>{
          console.error('error', error)
        })
    },
    cancelEditCategory(){
      this.showModalEdit= !this.showModalEdit; 
      this.isCancel=true;
    },
    onSubmitEditCategory(){
      this.loading=true;
      this.v$.$validate();
      if (!this.v$.$error && !this.isCancel) {
        let data = {
          name: this.categoryTitle,
        };
        CategorieService.update(this.categoryId, data)
        .then(() => {
          this.loading=false;
            this.getResults();
        })
        .finally(() => {
          this.$nextTick(() => {
            this.showModalEdit = false;
          });
        });  
      }
    }
  },
};
</script>

